import styled from "styled-components";
import {ThemeProvider} from "@mui/material/styles";
import {Box, IconButton, InputAdornment, TextField, Button} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { GeneralButtonStyled } from "./components/generalStyles";


{/* In the login, we will verify each restaurant and if they have a role we will give them access to the
    restaurants list 

    The registeration/login form is the only form where all the functions are here...
    maybe in the future we will split the functions into a different script
*/}

function AllRestaurantsLogin({}) {

    {/* ALL THE COSNTANTS AND VARIABLES GO HERE */}
    const url = process.env.NODE_ENV == "development" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    var from;

    //the text fields of the form
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    })

    //hooks for the errors of the text fields
    const [fieldErrors, setFieldsErrors] = useState({
        email_err: '',
        password_err: '',
    })

    //hooks to trigger field errors
    const [triggerFieldError, setTriggerFieldError] = useState({
        email_err_bool: false,
        password_err_bool: false,
    })

    //hook to show or hide password
    const [showPassword, setShowPassword] = useState(false);

    {/* ALL THE FORM FUNCTIONS GO HERE */}
    //function which handles the form text fields
    function handleChange(e) {
        const {name, value} = e.target;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }))
    }

    //a function to show or hide password when user clicks on eye icon
    function handleClickShowPassword() {
        setShowPassword(!showPassword);
    }

    //this function checks for form errors
    //returns 1 if error exists
    function checkForError() {
        var errorExists = 0;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; //checks if the email is valid or not
        setFieldsErrors((prevErrors) => ({
            "email_err": '',
            "password_err": '',
        }))
        setTriggerFieldError((prevErrors) => ({
            "email_err_bool": false,
            "password_err_bool": false,
        }))

        if(formData.email == '') {
            setFieldsErrors((prevErrors) => ({
                ...prevErrors,
                "email_err": "Please enter an email address!"
            }))
            setTriggerFieldError((prevErrors) => ({
                ...prevErrors,
                "email_err_bool": true
            }))
            errorExists = 1;
        }

        if(!emailRegex.test(formData.email)) {
            setFieldsErrors((prevErrors) => ({
                ...prevErrors,
                "email_err": "Please enter a valid email address."
            }))
            setTriggerFieldError({
                ...triggerFieldError,
                "email_err_bool": true,
            })
            errorExists = 1;
        }
        
        if(formData.password == '') {
            setFieldsErrors((prevErrors) => ({
                ...prevErrors,
                "password_err": "Please enter your password!"
            }))
            setTriggerFieldError((prevErrors) => ({
                ...prevErrors,
                "password_err_bool": true,
            }))
            errorExists = 1;
        }
        if(errorExists == 1) {
            return true;
        }
        else {
            return false;
        }
    }

    //function to submit the form
    //backend then authenticates and authorize users
    //returns a cookie (token)
    async function handleFormSubmit(e) {
        e.preventDefault();
        const errorExists = checkForError();
        
        if(errorExists) {
            alert("Please fill the fields marked in red!")
        } else {
            //setLoading(true);
            console.log("the url we r posting to is: ", url);
            try {
                const {data:{user: user}} = await axios.post(`${url}/auth/login`, formData, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                })

                //if admin role, navigate to restaurants list
                //else navigate to restaurant owner's dashboard
                console.log(user);

                if(user.role == "le-bleu") { //change this later to admin role
                    console.log("i hit it here")
                    from = location.state?.from?.pathname || `/restaurants/menus/admin/restaurants`
                    navigate(from, {replace: true})
                } else {
                    //navigates restaurant owner to its respective restaurant
                    navigate(`/restaurants/menus/admin/restaurants/${user.role}`, {replace: true});
                }
            } catch (error) {
                console.log("Error message from server", error.response.data.msg);
                alert("Please enter the correct email or password");
            }
    }
}

    
    return (
   <>
    <FormContainerStyled onSubmit = {handleFormSubmit}>
        <Box
            component = "form"
            sx = {{
                display: 'flex',
                flexDirection: 'column',
                gap: 7,
                width: "50%",
            }}
            noValidate
            autoCapitalize="off"
        >
            <TextField
                required
                id = "standard-basic"
                label = "Email"
                name = "email"
                value = {formData.email}
                onChange = {handleChange}
                helperText = {fieldErrors.email_err}
                error = {triggerFieldError.email_err_bool}
            >
            </TextField>
            <TextField
                required
                id = "standard-basic"
                type = {showPassword ? "text" : "password"}
                label = "Password"
                name =  "password"
                value = {formData.password}
                onChange = {handleChange}
                helperText = {fieldErrors.password_err}
                error = {triggerFieldError.password_err_bool}
                InputProps = {{
                    endAdornment: (
                        <InputAdornment position = "end">
                            <IconButton
                                aria-label = "toggle password visibility"
                                onClick = {handleClickShowPassword}
                                edge = "end"
                            >
                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            >
            </TextField>
            <BottomContainerStyled>
                <ThemeProvider theme = {GeneralButtonStyled}>
                    <Button type = "submit" variant = "contained" color = "primary" style = {{width: "100%"}}>
                        login
                    </Button>
                </ThemeProvider>
            </BottomContainerStyled>
        </Box>
    </FormContainerStyled>
   </>
    )
}

const FormContainerStyled = styled.div`
    position: relative;
    display:  flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    padding: 40px 0px;
`

const LoadingBoxStyled = styled(FormContainerStyled)``

const BottomContainerStyled = styled.div`
    position: relative;
    margin: 0 auto;
    width: 50%;
    scale: 1;
    transition: all 300ms;

    &:hover {
        scale: 1.05
    }
`



export default AllRestaurantsLogin;